/* @desc 跨行转账相关接口
 * @Email: zheniscool@163.com
 * @FilePath: /cbibank-web-corporbank/src/api/interbank-transfers.js
 * @Date: 2021-12-15 20:52:49
 * @Author: zhangzhen
 * @LastEditTime: 2021-12-15 20:52:49
 */

import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'
import store from '@/store'

export default {
  /**
  * 获取权限菜单
  * @param {string} accountNo 账户号
  * @param {string} currentBusinessCode 10200010 固定值
  */
  accountStatusCheck (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/accountStatusCheck.do`, params, config, 'URLEncoded')
  },
  /**
  * 获取默认账户信息（汇款人姓名/地址）
  * @param {string} currentBusinessCode '10700700' 固定值
  */
  companyDetailManage (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/10700700_companyDetailManage.do`, params, config, 'URLEncoded')
  },
  /**
  * 账户余额显示: 根据币种精度,JPY,KRW:显示到个位  其他币种:显示到分位
  * @param {string} accountNo 账户号
  * @param {string} currentBusinessCode 10100000 固定值
  */
  accountBalanceQuery (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/accountBalanceQuery.do`, params, config, 'URLEncoded')
  },
  /**
  * 查询单笔限额
  * @param {string} accountNo 账户号
  */
  queryTransferLimit (params = {}, config = {}) {
    return api.post('/api/transfer/acct/limit/tran', params, config, 'URLEncoded')
  },
  /**
  * 查询手续费
  * @param {string} recBankType '1' 固定值
  * @param {string} currentBusinessCode '10200300' 固定值
  * @param {string} systemCode '1' 固定值
  * @param {string} payAmount 汇出金额
  * @param {string} payAccount 汇款账号
  * @param {string} channel 1103' 固定值
  * @param {string} feeType 002' 固定值
  * @param {string} currencyType 货币类型
  * @param {string} FeeFlg '费用承担方'
  */
  queryChargeFee (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/queryChargeFee.do`, params, config, 'URLEncoded')
  },
  /**
  * 检查是否符合MSB规则
  * @param {string} ownAcc  payAccount
    @param {string} otherAcc recAccount
  */
  canTransfer (params = {}, config = {}) {
    return api.post('/api/msb/payment/canTransfer', params, config, 'URLEncoded')
  },
  /**
  * 查询转账是否超出限额
  * @param {string} payAmount
    @param {string} payAccount
    @param {string} currencyType
    @param {string} currentBusinessCode 固定值 '10200010'
  */
  accLimitQueryGRB (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/accLimitQueryGRB.do`, params, config, 'URLEncoded')
  },
  /**
  * 查询收款人详细信息
    @param {string} recAccount 收款人账户
  */
  getCustomerPayeeDetail (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/getCustomerPayeeDetail.do`, params, config, 'URLEncoded')
  },
  /**
  * 查询收看人信息
    @param {string} searchAccount 收款人账户
    @param {string} currentBusinessCode: 10200500 固定值
  */
  customerPayeeInfo (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/customerPayeeInfo.do`, params, config, 'URLEncoded')
  },
  /** 检查ABACode
   * @param {string} routing
   */
  checkABACode (params = {}, config = {}) {
    return api.post('/api/aba/find', params, config, 'URLEncoded')
  },
  /** 检查SWIFT
   * @param {string} swiftCode
   */
  checkBankSwift (params = {}, config = {}) {
    return api.post('/api/sanction/one', params, config, 'URLEncoded')
  },
  /**
   * 获取收款银行地区与收款银行
  */
  getRegionAndBank (params = {}, config = {}) {
    return api.post(`/api/pub/archive?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },
  /**
   * 根据收款银行地区与收款银行获取支行
   * @param {string} province bankRegion字段
   * @param {string} headOffice bank字段
   */
  getBranchBank (params = {}, config = {}) {
    return api.post(`/api/pub/list?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  }
}
